import { type LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export function Label({ className, ...rest }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      className={cn(
        'block text-xs font-semibold text-slate-700 uppercase tracking-wide',
        className,
      )}
      {...rest}
    />
  );
}
